import React, { Component } from 'react';

export default class CouponBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            show: true
        }
    }

    render() {
        const { num = 0 } = this.props; 
        const  {show } = this.state;
        const clickHandler = () => {
            this.setState({ show: false })
        }
        return num && show ?
            <div className="np-buylogin">
                <div className="np-main">
                    <p>您有 <span className="oc-col-blue">{num}</span> 张可使用的优惠券，立即下单使用吧！<i className="i-close" title="关闭" onClick={clickHandler}></i></p>
                </div>
            </div> : null
    }
    
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/CouponBar.jsx